import { useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { useAudioPlayer } from '../../contexts/AudioPlayerContext';
import PodcastPlayerBar from './PodcastPlayerBar';
import MusicPlayerBar from './MusicPlayerBar';

export default function GlobalAudioPlayer() {
  const { currentMedia } = useAudioPlayer();
  const location = useLocation();

  if (!currentMedia) return null;

  // Suppress floating bar when user is on the detail page of the currently playing sermon
  if (
    (currentMedia.type === 'podcast' || currentMedia.type === 'sermon') &&
    currentMedia.slug &&
    location.pathname === `/sermons/${currentMedia.slug}`
  ) {
    return null;
  }

  return (
    <AnimatePresence>
      <motion.div
        key="global-audio-player"
        initial={{ y: 100 }}
        animate={{ y: 0 }}
        exit={{ y: 100 }}
        transition={{ type: 'spring', damping: 25, stiffness: 300 }}
        className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-xl z-50"
      >
        {currentMedia.type === 'music' ? <MusicPlayerBar /> : <PodcastPlayerBar />}
      </motion.div>
    </AnimatePresence>
  );
}
